import { useEffect, useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { useAuth } from '@/context/AuthContext';

export default function PaymentSuccessHandler() {
  const location = useLocation();
  const navigate = useNavigate();
  const { refreshProfile } = useAuth();
  const [showBanner, setShowBanner] = useState(false);
  const [planName, setPlanName] = useState('');

  useEffect(() => {
    const params = new URLSearchParams(location.search);
    const paymentSuccess = params.get('payment_success');
    const plan = params.get('plan');

    if (paymentSuccess === 'true' && plan) {
      setPlanName(plan.charAt(0).toUpperCase() + plan.slice(1));
      setShowBanner(true);

      // Refresh profile to get updated plan from Supabase
      const refresh = async () => {
        // Small delay to let webhook process
        await new Promise((r) => setTimeout(r, 1500));
        await refreshProfile();
      };
      refresh();

      // Clean URL without reloading
      const cleanUrl = window.location.pathname;
      window.history.replaceState({}, '', cleanUrl);

      // Auto-hide after 6s
      const timer = setTimeout(() => setShowBanner(false), 6000);
      return () => clearTimeout(timer);
    }
  }, []);

  if (!showBanner) return null;

  return (
    <div className="fixed top-5 left-1/2 -translate-x-1/2 z-[300] w-full max-w-md px-4">
      <div className="bg-[#0d0f14] border border-[#00e87a]/40 rounded-2xl px-5 py-4 flex items-center gap-4">
        <div className="w-10 h-10 rounded-full bg-[#00e87a]/10 flex items-center justify-center flex-shrink-0">
          <i className="ri-checkbox-circle-fill text-[#00e87a] text-xl"></i>
        </div>
        <div className="flex-1">
          <p className="text-white text-sm font-bold">¡Pago completado!</p>
          <p className="text-[#a8b2c1] text-xs mt-0.5">
            Tu plan <span className="text-[#00e87a] font-semibold">{planName}</span> ya está activo. Bienvenido.
          </p>
        </div>
        <button
          onClick={() => setShowBanner(false)}
          className="w-7 h-7 flex items-center justify-center text-[#6b7280] hover:text-white cursor-pointer flex-shrink-0"
        >
          <i className="ri-close-line"></i>
        </button>
      </div>
    </div>
  );
}
